var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('img',{attrs:{"width":_vm.width,"src":require("@/assets/img/loading-lg.svg"),"alt":"Carregando rapá"}})])}
var staticRenderFns = []

export { render, staticRenderFns }